import { render, staticRenderFns } from "./ProjectManager.vue?vue&type=template&id=6f4e65e8"
import script from "./ProjectManager.vue?vue&type=script&lang=js"
export * from "./ProjectManager.vue?vue&type=script&lang=js"
import style0 from "./ProjectManager.vue?vue&type=style&index=0&id=6f4e65e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports